import * as React from 'react';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import logo from '../vdoo.png'
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation} from 'react-router-dom';

import Navigation from './global_navigation';
import ToDoList from '../toDoList/toDoList'
import Contact from '../contact-forms/contact';
import CalendarView from '../calendar/CalendarView';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(1),
    paddingTop: '64px', // AppBar height
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '100%',
    maxWidth: '100vw',
    boxSizing: 'border-box',
    overflow: 'hidden',
    // Only apply negative margin on desktop where drawer is persistent
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
      marginLeft: `-${drawerWidth}px`,
      ...(open && {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    },
    // On mobile, no margin shift needed (drawer overlays)
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  backgroundColor: '#3a1a5a',
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // Only shift AppBar on desktop (md and up), not on mobile where drawer is temporary
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }),
}));


export default function Dashboard(user) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(!isMobile);
  const location = useLocation();

  // Update drawer state when screen size changes
  React.useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const renderContent = () => {
    switch (location.pathname) {
      case '/contact':
        return (
          <>
            <Contact {...user} showResolved={false} />
          </>
        );
      case '/contact/resolved':
        return (
          <>
            <Contact {...user} showResolved={true} />
          </>
        );
      case '/calendar':
        return <CalendarView user={user} />;
      default:
        return <ToDoList {...user} />;
    }
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100vw', overflow: 'hidden' }}>
      <CssBaseline />
      <AppBar component="nav" open={open}>
        <Toolbar sx={{ minHeight: isMobile ? '56px' : '64px' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: isMobile ? 1 : 2, ...(open && { display: 'none' }) }}
          >
          <MenuIcon style={{...(open && { display: 'none' }) }}/>
          </IconButton>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }} >
            <img src={logo} alt="logo" style={{height: isMobile ? 35 : 50}} />
          </Box>
          <Typography
            variant={isMobile ? "body1" : "h6"}
            noWrap
            component="div"
            sx={{
              marginLeft: isMobile ? 0.5 : 1,
              fontSize: isMobile ? '0.9rem' : undefined
            }}
          >
            Todos
          </Typography>
        </Toolbar>
      </AppBar>
      <Navigation />
      <Main open={open}>
      {renderContent()}
      </Main>
    </Box>
  );
}